import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./Navbar.module.css";
import Button from "@mui/material/Button";
import AcUnitOutlinedIcon from "@mui/icons-material/AcUnitOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import ApiOutlinedIcon from "@mui/icons-material/ApiOutlined";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import { makeStyles } from "@mui/styles";
import { useTheme } from "@mui/material/styles";
import HomeIcon from "../components/icons/HomeIcon";
import FingerPrintIcon from "../components/icons/FingerPrintIcon";
import BillIcon from "../components/icons/BillIcon";
import CardsIcon from "../components/icons/CardsIcon";
import ProjectsIcon from "../components/icons/ProjectsIcon";
import UsersIcon from "../components/icons/UsersIcon";
import FiberManualRecordOutlinedIcon from "@mui/icons-material/FiberManualRecordOutlined";
// import RefreshToken from "../../services/RefreshToken";

const useStyles = makeStyles((theme) => ({
  button_style: {
    color: `${theme.palette.text.main} !important`,
    fontWeight: "500 !important",
    padding: "8px 10px",
    borderRadius: "6px",
    fontSize: "0.875rem",
    textTransform: "none",
  },

  active_button_style: {
    background: `${theme.palette.primary.main} !important`,
    color: `#fff !important`,
    "& span svg path": { stroke: "#fff !important" },
  },
}));
const Navbar = () => {
  const theme = useTheme();
  let pathname = useLocation().pathname;
  const classes = useStyles();
  const [active, setActive] = useState("");

  const checkusersRoute = () => {
    const userPathname = ["/user-list","/user-details"];
    if (userPathname.includes(pathname)) {
      return true;
    } else {
      return false;
    }
  };
  const checkBillingRoute = () => {
    const userPathname = ["/billing"];
    if (userPathname.includes(pathname)) {
      return true;
    } else {
      return false;
    }
  };
  const checkCardRoute = () => {
    const userPathname = ["/cards"];
    if (userPathname.includes(pathname)) {
      return true;
    } else {
      return false;
    }
  };
  const checkProjectsRoute = () => {
    const userPathname = ["/projects"];
    if (userPathname.includes(pathname)) {
      return true;
    } else {
      return false;
    }
  };
  const checkPagesRoute = () => {
    const userPathname = ["/user-list","/user-details"];
    if (userPathname.includes(pathname)) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <div>
      <nav className={styles.nav}>
        <div className={styles.dropdown}>
          <Button
            disableRipple
            disableElevation
            className={`${classes.button_style} ${
              pathname === "/dashboard" ? classes.active_button_style : null
            }`}
            startIcon={<HomeIcon color={theme.palette.text.light} />}
            component={Link}
            to="/dashboard"
          >
            Dashboard
          </Button>
        </div>
        <div className={styles.dropdown}>
          <Button
            disableRipple
            disableElevation
            className={`${classes.button_style} ${
              checkusersRoute() ? classes.active_button_style : null
            }`}
            startIcon={<FingerPrintIcon color={theme.palette.text.light} />}
            // endIcon={<KeyboardArrowDownOutlinedIcon />}
            component={Link}
            to="/user-list"
          >
            E-KYC Profile
          </Button>
        </div>
        <div className={styles.dropdown}>
          <Button
            disableRipple
            disableElevation
            className={`${classes.button_style} ${
              checkBillingRoute() ? classes.active_button_style : null
            }`}
            startIcon={<BillIcon color={theme.palette.text.light} />}
            // endIcon={<KeyboardArrowDownOutlinedIcon />}
            component={Link}
            to="/billing"
          >
            Billing
          </Button>
          {/* <div className={styles.dropdown_content}>
            <Link to="/user-list" className={styles.nav_container}>
              <section className={styles.nav_item}>
                <div className={styles.left_Icon}>
                  <AcUnitOutlinedIcon />
                </div>
                <div className={styles.list_item_title}>
                  User list
                  <KeyboardArrowRightOutlinedIcon />
                </div>
              </section>

              <section className={styles.nav_subitem_dropdown_content}>
                <Link to="#" className={styles.nav_item}>
                  <div className={styles.left_Icon}>
                    <AcUnitOutlinedIcon />
                  </div>
                  <div className={styles.list_item_title}>Test 1</div>
                </Link>
                <Link to="#" className={styles.nav_item}>
                  <div className={styles.left_Icon}>
                    <AcUnitOutlinedIcon />
                  </div>
                  <div className={styles.list_item_title}>test 2</div>
                </Link>
              </section>
            </Link>
            <Link to="/profile-creation" className={styles.nav_container}>
              <section className={styles.nav_item}>
                <div className={styles.left_Icon}>
                  <AcUnitOutlinedIcon />
                </div>
                <div className={styles.list_item_title}>
                  Profile creation
                  <KeyboardArrowRightOutlinedIcon />
                </div>
              </section>

              <section className={styles.nav_subitem_dropdown_content}>
                <Link to="#" className={styles.nav_item}>
                  <div className={styles.left_Icon}>
                    <AcUnitOutlinedIcon />
                  </div>
                  <div className={styles.list_item_title}>Test 1</div>
                </Link>
                <Link to="#" className={styles.nav_item}>
                  <div className={styles.left_Icon}>
                    <AcUnitOutlinedIcon />
                  </div>
                  <div className={styles.list_item_title}>test 2</div>
                </Link>
              </section>
            </Link>
            <Link to="/user-access-control" className={styles.nav_container}>
              <section className={styles.nav_item}>
                <div className={styles.left_Icon}>
                  <AcUnitOutlinedIcon />
                </div>
                <div className={styles.list_item_title}>
                  User access control
                  <KeyboardArrowRightOutlinedIcon />
                </div>
              </section>

              <section className={styles.nav_subitem_dropdown_content}>
                <Link to="#" className={styles.nav_item}>
                  <div className={styles.left_Icon}>
                    <AcUnitOutlinedIcon />
                  </div>
                  <div className={styles.list_item_title}>Test 1</div>
                </Link>
                <Link to="#" className={styles.nav_item}>
                  <div className={styles.left_Icon}>
                    <AcUnitOutlinedIcon />
                  </div>
                  <div className={styles.list_item_title}>test 2</div>
                </Link>
              </section>
            </Link>
          </div> */}
        </div>
        <div className={styles.dropdown}>
          <Button
            disableRipple
            disableElevation
            className={`${classes.button_style} ${
              checkCardRoute() ? classes.active_button_style : null
            }`}
            startIcon={<CardsIcon color={theme.palette.text.light} />}
            // endIcon={<KeyboardArrowDownOutlinedIcon />}
            component={Link}
            to="/cards"
          >
            My Cards
          </Button>
          {/* <div className={styles.dropdown_content}>
            <Link to="/cards" className={styles.nav_container}>
              <section className={styles.nav_item}>
                <div className={styles.left_Icon}>
                <CardsIcon color={theme.palette.text.light} />
                </div>
                <div className={styles.list_item_title}>
                  Cards
            
                </div>
              </section>
            </Link>
          </div> */}
        </div>
        <div className={styles.dropdown}>
          <Button
            disableRipple
            disableElevation
            className={`${classes.button_style} ${
              checkProjectsRoute() ? classes.active_button_style : null
            }`}
            startIcon={<ProjectsIcon color={theme.palette.text.light} />}
            component={Link}
            to="/projects"
          >
            Projects
          </Button>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
